

export default function(){
    return (
        <div>
            <iframe title="iframe" src='./vr-app/index.htm' style={{ width: '100%', height: '1080px', marginTop: '100px' }}/>
        </div>
    )
}